import { Link } from "react-router-dom";
import { MARKETING_PHASES } from "../../lib/marketingSandboxFixtures";

const PHASE_LABELS = {
  intake: "Core intake",
  summary_review: "Summary review",
  live_bids: "Live bid search",
};

/**
 * Floating debug panel for marketing screenshots. Render only when
 * `isMarketingDebugControlsEnabled()` is true (never on prod builds).
 */
export default function MarketingSandboxControls({
  phase,
  onPhaseChange,
  forceUnreadBadge,
  onToggleForceUnreadBadge,
  onMobileGrabPreset,
  onOpenMobileBids,
  onOpenDesktopBids,
  isMobile,
}) {
  return (
    <div
      className="fixed bottom-4 left-4 z-[9999] max-w-[min(100vw-2rem,320px)] rounded-xl border border-slate-700/80 bg-slate-900/95 p-3 text-xs text-slate-100 shadow-2xl backdrop-blur-sm"
      role="region"
      aria-label="Marketing sandbox controls"
    >
      <div className="mb-2 font-semibold uppercase tracking-wide text-orange-400">
        Marketing sandbox
      </div>
      <p className="mb-3 leading-snug text-slate-400">
        St. Louis three-season room · debug only
      </p>

      <div className="mb-3">
        <div className="mb-1.5 font-medium text-slate-300">Layout phase</div>
        <div className="flex flex-wrap gap-1.5">
          {MARKETING_PHASES.map((p) => (
            <button
              key={p}
              type="button"
              onClick={() => onPhaseChange(p)}
              className={`rounded-md px-2.5 py-1.5 font-medium transition-colors ${
                phase === p
                  ? "bg-orange-600 text-white"
                  : "bg-slate-800 text-slate-200 hover:bg-slate-700"
              }`}
            >
              {PHASE_LABELS[p]}
            </button>
          ))}
        </div>
      </div>

      <div className="mb-3 flex flex-wrap gap-1.5">
        <button
          type="button"
          onClick={onToggleForceUnreadBadge}
          className={`rounded-md px-2.5 py-1.5 font-medium transition-colors ${
            forceUnreadBadge
              ? "bg-orange-600 text-white"
              : "bg-slate-800 text-slate-200 hover:bg-slate-700"
          }`}
        >
          $ radar pulse: {forceUnreadBadge ? "Locked ON" : "Auto"}
        </button>
        {isMobile ? (
          <button
            type="button"
            onClick={onMobileGrabPreset}
            className="rounded-md bg-slate-800 px-2.5 py-1.5 font-medium text-slate-200 hover:bg-slate-700"
          >
            Mobile $ grab preset
          </button>
        ) : null}
        {isMobile ? (
          <button
            type="button"
            onClick={onOpenMobileBids}
            className="rounded-md bg-slate-800 px-2.5 py-1.5 font-medium text-slate-200 hover:bg-slate-700"
          >
            Open bids drawer
          </button>
        ) : (
          <button
            type="button"
            onClick={onOpenDesktopBids}
            className="rounded-md bg-slate-800 px-2.5 py-1.5 font-medium text-slate-200 hover:bg-slate-700"
          >
            Scroll to bids panel
          </button>
        )}
      </div>

      <div className="border-t border-slate-700 pt-2 text-slate-500">
        <Link
          to="/engine?debug=true"
          className="text-orange-400 hover:text-orange-300"
        >
          Engine dashboard (debug)
        </Link>
        {" · "}
        <span className="text-slate-500">
          2s scale(4) radar pulse on $
        </span>
      </div>
    </div>
  );
}
